<template>
  <div class="view order-view">
    <HeaderBar />
    <van-tabs v-model="active" @change="onActiveChange" swipeable>
      <van-tab title="待付款">
        <div class="course-item-wrap">
          <CourseItem v-for="item in list" :key="item.id" v-bind="item" />
        </div>
      </van-tab>
      <van-tab title="已付款">
        <div class="course-item-wrap">
          <CourseItem v-for="item in list" :key="item.id" v-bind="item" />
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { Tab, Tabs } from 'vant';
import apiConst from '../../consts/apiConst';
import apiUtil from '../../utils/apiUtil';
import CourseItem from '../../components/CourseItem';
import HeaderBar from '../../components/HeaderBar';

export default {
  name: 'order',
  components: {
    'van-tabs': Tabs,
    'van-tab': Tab,
    CourseItem,
    HeaderBar
  },
  data() {
    return {
      active: 0,
      list: [],
      type: 1
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init(type = 1) {
      const res = await apiUtil.post(apiConst.getOrder, { type });
      if (res.success) {
        this.list = res.list.map(ele => {
          ele = {
            status: ele.status,
            ...ele.course_info
          };
          return ele;
        });
      }
    },

    onActiveChange(index, title) {
      console.log(index);
      this.init(index + 1);
    }
  }
};
</script>
<style lang="stylus" scoped>
.order-view {
  .course-item-wrap {
    padding: 0 15px;
    .course-item-comp {
      margin: 30px 15px;
    }
  }
}
</style>
